import * as _User from "./Reducers/User";
import * as _Lang from "./Reducers/Lang";
import * as _AppState from "./Reducers/AppState";
import { namedExportWithMemorizedOnce } from "./Utils/FpUtil";
import ParseQuery from "./Utils/ParseQuery";

let User = namedExportWithMemorizedOnce(_User);
let Lang = namedExportWithMemorizedOnce(_Lang);
let AppState = namedExportWithMemorizedOnce(_AppState);

const selectors = {
  getQueryParams: ownProps => ParseQuery(ownProps.location.search),
  getLang: state => Lang.getLang(state.lang),
  getLoginUser: state => User.getLoginUser(state.user),
  autologinProcessing: state => AppState.autologinProcessing(state.appState),
};

export default selectors;
